/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Users_VenueInputs */

const cs_settings_users_venue = /** @type {(inputs: Settings_Users_VenueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pobočka`)
};

const en_settings_users_venue = /** @type {(inputs: Settings_Users_VenueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Venue`)
};

/**
* | output |
* | --- |
* | "Venue" |
*
* @param {Settings_Users_VenueInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const settings_users_venue = /** @type {((inputs?: Settings_Users_VenueInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Users_VenueInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_settings_users_venue(inputs)
	return cs_settings_users_venue(inputs)
});